import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getUserGroups = () => {
  return API.get(`${getApiUrl()}/api/permissions/groups`);
};

export const setUserGroups = (groups) => {
  return API.post(`${getApiUrl()}/api/permissions/groups`, groups);
};

export const userGroupService = {
  getUserGroups,
  setUserGroups
  
}; 